import { CreateProfileContainer, LoginContainer } from "../pages/Onboarding/containers";
import { Navigate, Route, Routes } from "react-router-dom";

import Landing from "../pages/Landing/Landing";
import { PAGES_PATH } from "./params";
import React from "react";
import { PrivacyPolicy } from "../pages/PrivacyPolicy";
import { TermsAndConditions } from "../pages/TermsAndConditions";
import { VersionsView } from "../pages/Versions";
import { HealthView } from "../pages/HealthView";

const PublicRoutesContainer = () => {
  return (
    <Routes>
      <Route
        path={PAGES_PATH.HEALTH}
        element={<HealthView />}
      />
      <Route path={PAGES_PATH.PRIVACY_POLICY} element={<PrivacyPolicy />} />
      <Route
        path={PAGES_PATH.TERMS_CONDITIONS}
        element={<TermsAndConditions />}
      />
      <Route path={PAGES_PATH.VERSIONS} element={<VersionsView />} />
      <Route path={PAGES_PATH.SIGN_UP} element={<CreateProfileContainer />} />
      <Route path={PAGES_PATH.SIGN_IN} element={<LoginContainer />} />
      <Route path={PAGES_PATH.LANDING} element={<Landing />} />
      <Route path="*" element={<Navigate to={PAGES_PATH.LANDING} />} />
    </Routes>
  );
};

export default PublicRoutesContainer;
